<template lang="pug">
el-form(
  ref="refForm"
  :rules="rules"
  :model="item"
  status-icon
  label-position="top"
).c-org-edit-form
  app-main-content-layout(title='Organization Detail' :back-to="backLink()")
    template(#actions)
      template(v-if="item.approved")
        el-button(type="default" plain).button-dark-outlined.min-w-110
          fai(type="fal" icon="envelope").size-18
          span Send Message

        el-button(type="primary" @click="validateForm" v-loading="loading").has-fai.min-w-110
          fai(type="fal" icon="save").size-18
          span Save
      template(v-if="!item.approved")
        el-button(type="primary" @click="approveOrg(true)" v-loading="loading").has-fai.min-w-110
          fai(type="fal" icon="check").size-18
          span Approve
        el-button(type="danger" plain @click="approveOrg(false)" v-loading="loading").has-fai.min-w-110
          fai(type="fal" icon="times").size-18
          span Deny

    template(#col-left)
      .c-content-section
        .row
          .col-md-6
            el-form-item(label="Organization Name" prop="name")
              el-input(v-model="item.name")
          .col-md-6
            el-form-item
              template(#label)
                | Slug
                el-tooltip(
                  effect="customized"
                  :content="slugTip"
                  placement="top"
                  popper-class="max-w-350"
                )
                  fai(type="fal" icon="info-circle").size-18.ms-2
              el-input(v-model="item.slug" @input="sanitizeSlug")

        el-form-item(v-if="item.stripe_onboarded" label="Payment Integration")
          .link-input-group
            el-input(v-model="item.isStripeOnboarded" readonly)
            el-button(type="danger" size="small" @click="removeStripeConnection")
              span Remove

        el-form-item
          template(#label)
            | About
            el-tooltip(
              effect="customized"
              :content="aboutTip"
              placement="top"
              popper-class="max-w-350"
            )
              fai(type="fal" icon="info-circle").size-18.ms-2
          el-input(v-model="item.about" type="textarea" :rows="6")

        el-form-item.mb-0
          template(#label)
            | {{ item.organization_type === 'NONPROFIT' ? "Our Purpose" : "Our Ethos" }}
            el-tooltip(
              effect="customized"
              :content="purposeTip"
              placement="top"
              popper-class="max-w-350"
            )
              fai(type="fal" icon="info-circle").size-18.ms-2
          el-input(v-model="item.purpose" type="textarea"  maxlength="125" show-word-limit :rows="4")

      .c-content-section.mt-3
        user-common-sections(:item="item")

      .c-content-section.mt-3
        el-form-item(label="In-App Organization Link")
          .link-input-group
            el-input(:value="orgDeepLink" readonly size="small")
            el-button(type="primary" size="small" @click="copyOrgDeepLink")
              span.ms-1 Copy

        el-form-item(label="Embed Code")
          .embed-input-wrapper.mb-2
            label.embed-label Website Domain
            el-input(v-model="embedConfig.website" placeholder="example.com" @input="sanitizeWebsite" size="small")
          .bg-light.p-2.rounded.mb-2(style="max-height: 150px; overflow-y: auto;")
            pre.mb-0(style="font-size: 11px; line-height: 1.3; white-space: pre-wrap;") {{ embedCode }}
          el-button(type="primary" @click="copyEmbedCode" size="small")
            span Copy Code

    template(#col-right)
      .c-content-section
        .row
          .col-md-6
            h5.mb-3 Avatar
            el-upload(
                :show-file-list="false"
                :on-success="handleSuccess"
                :on-error="handleError"
                :before-upload="beforeUpload"
                :http-request="handleAvatarUpload"
                v-loading="uploading.avatar"
                action=""
            ).img-uploader.pos-r.mb-4
                template(v-if="item.avatar")
                  img(:src="item.avatar").img-fluid.uploaded-image
                  .pin.pin-bx.d-flex.p-2
                    el-button(type="primary").ms-auto Change
                template(v-else)
                  .upload-empty-state
                    img(src="@/assets/icons/file-image-outline.svg").img-uploader-icon
                    p.upload-picture-text Drop image here or
                    el-button(type="primary" size="small").fake-upload-button Browse
          .col-md-6
            h5.mb-3 Background
            el-upload(
                :show-file-list="false"
                :on-success="handleSuccess"
                :on-error="handleError"
                :before-upload="bUploads.beforeUpload"
                :http-request="handleBackgroundUpload"
                v-loading="uploading.background"
                action=""
            ).img-uploader.pos-r.mb-4
              template(v-if="item.background")
                img(:src="item.background").img-fluid.uploaded-image
                .pin.pin-bx.d-flex.p-2
                  el-button(type="primary").ms-auto Change
              template(v-else)
                .upload-empty-state
                  img(src="@/assets/icons/file-image-outline.svg").img-uploader-icon
                  p.upload-picture-text Drop image here or
                  el-button(type="primary" size="small").fake-upload-button Browse

      .c-content-section.mt-3
        el-form-item(label="Account Status")
          VueMultiselect(
              v-model="item.active",
              :multiple="false",
              label="type",
              track-by="value",
              :options="accountStatus.items",
              :searchable="false",
              :close-on-select="true",
              :show-labels="false"
              placeholder="Select"
            )

        el-form-item(label="Permissions")
          .d-flex
            div Creator
            el-switch.ms-auto(
              v-model="item.is_creator"
              active-color="#13ce66"
              active-value=true
              inactive-value=false)

        el-form-item(label="Featured")
          .d-flex
            div Featured Organization
            el-switch.ms-auto(
              v-model="item.isFeatured"
              active-color="#13ce66"
              active-value=true
              inactive-value=false)

        el-form-item(label="Share Organization Profile")
          .qr-code-section
            qrcode-vue(:value="orgUrl" :size="220")
            .link-with-copy.mt-2
              a.primary-color-text(
                :href="orgUrl"
                target="_blank"
                rel="noopener noreferrer"
              ) {{ orgUrl }}
              el-button(type="primary" size="small" @click.stop="copyOrgUrl").ms-2
                span Copy

      .c-content-section.mt-3
        el-form-item(label="Category")
          .categories-list
            el-tag(
              type="info" :key="index"
              v-for="(category, index) in item.categories"
            ) {{ category }}

        el-form-item(label="Organization Type")
          el-input(v-model="item.orgType" disabled)

        el-form-item(label="Email" prop="email")
          el-input(v-model="item.email" type="email" v-lowercase-email)

        el-form-item(label="Date Established")
          el-date-picker(
            v-model="item.estdDate"
            type="date"
            placeholder="MM / DD/ YYYY"
            format="MM/DD/YYYY"
            disabled
          ).w-100

        el-form-item(label="Referral Code Used")
          el-input(v-model="item.referralCodeUsed" disabled)

        el-form-item
          template(#label) Created
            span.text-muted.ms-2
          el-input(v-model="item.createdAt" disabled)

        el-form-item(v-if="item.admins && item.admins.length")
          template(#label) Admins
          .admins-list
            .admin-item(v-for="admin in item.admins" :key="admin.id")
              .row.row-xs.align-items-center
                .col-auto
                  img(:src="admin.avatar"
                    v-if="admin.avatar").d-block.size-32.obj-f-c.rounded-circle
                  img(src="@/assets/images/default-profile.jpeg"
                    v-if="!admin.avatar").d-block.size-32.obj-f-c.rounded-circle
                .col.lh-1 {{ admin.firstname }} {{ admin.lastname }}
                .col-auto
                  el-button(
                    link
                    type="danger"
                    :disabled="item.admins.length == 1"
                    @click="removeAdminUserFromOrg(admin.id, $event)"
                    size="small"
                  ) Remove
                .col-auto
                  el-button(link type="primary" @click="viewUser(admin.id, $event)" size="small") View

          el-button(link @click="item.isAddAdmin = !item.isAddAdmin").mt-2
            fai(type="fal" icon="plus-circle")
            span Add Admin User

          .add-admin-form(v-if="item.isAddAdmin").mt-3
            .row
              .col-md-8
                el-input(v-model="item.adminEmail" placeholder="admin@example.com" v-lowercase-email size="small")
              .col-md-4
                el-button(type="primary" @click="addAdminUserToOrg" size="small")
                  span Add
</template>

<style lang="scss" scoped>
// Color Variables - Match ManageUsers.vue
$color-teal-accent: #01beb0;
$gray-50: #f9fafb;
$gray-100: #f3f4f6;
$gray-200: #e5e7eb;
$gray-300: #d1d5db;
$gray-400: #9ca3af;
$gray-500: #6b7280;
$gray-600: #4b5563;
$gray-700: #374151;
$gray-900: #111827;
$color-purple-text: #4349dd;

// Main Form Container
.c-org-edit-form {
  padding: 2rem;
  
  :deep(.grid-2-cols) {
    gap: 1.5rem;
  }
  
  :deep(.col-has-child) {
    display: flex;
    flex-direction: column;
    gap: 1rem;
  }
}

// White Content Sections
.c-content-section {
  background: white;
  border-radius: 14px;
  border: 1px solid rgba(0, 0, 0, 0.1);
  box-shadow: none;
  padding: 1.5rem;
  overflow: hidden;
}

// Link Input Group Styling
.link-input-group {
  display: flex;
  gap: 8px;
  align-items: center;
}

.link-input-group .el-input {
  flex: 1;
}

// Embed Input Wrapper Styling
.embed-input-wrapper {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;

  .embed-label {
    font-size: 0.75rem;
    font-weight: 600;
    color: $gray-600;
    text-transform: uppercase;
    letter-spacing: 0.025em;
  }

  :deep(.el-input-number) {
    width: 100%;
  }
}

// Form Styling
:deep(.el-form-item) {
  margin-bottom: 1.5rem;

  .el-form-item__label {
    color: #0a0a0a;
    font-weight: 500;
    font-size: 0.875rem;
    line-height: 1.5;
    margin-bottom: 0.5rem;
    display: flex;
    align-items: center;
    gap: 0.25rem;
  }

  .el-input__wrapper {
    border-radius: 8px;
    border: 1px solid transparent;
    background: #f3f3f5;
    box-shadow: none;
    padding: 0 12px;
    height: 36px;
    transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);

    &:hover:not(.is-disabled) {
      border-color: transparent;
      box-shadow: none;
    }

    &.is-focus {
      border-color: #01beb0;
      box-shadow: none;
    }

    &.is-disabled {
      border: 1px solid transparent;
      background: #f3f3f5;
    }
  }

  .el-input__inner {
    height: 100%;
    font-size: 0.875rem;
    color: $gray-700;
    background: transparent;
    font-weight: 500;

    &::placeholder {
      color: $gray-400;
      font-weight: 400;
    }
  }

  .el-textarea__inner {
    border-radius: 8px;
    border: 1px solid transparent;
    background: #f3f3f5;
    box-shadow: none;
    padding: 12px;
    color: $gray-700;
    font-weight: 500;
    font-size: 0.875rem;
    line-height: 1.5;
    transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
    min-height: 100px;

    &:hover {
      border-color: transparent;
      box-shadow: none;
    }

    &:focus {
      border-color: #01beb0;
      box-shadow: none;
    }

    &::placeholder {
      color: $gray-400;
      font-weight: 400;
    }
  }
}


// Switch Styling
:deep(.el-switch) {
  height: 24px;
  line-height: 24px;

  .el-switch__core {
    border-radius: 12px;
    height: 24px;
    min-width: 44px;
    border: 2px solid $gray-300;
    background-color: $gray-300;
    transition: all 0.3s;

    .el-switch__action {
      width: 20px;
      height: 20px;
      left: 2px;
      top: 50%;
      transform: translateY(-50%);
      transition: all 0.3s;
    }
  }

  &.is-checked {
    .el-switch__core {
      background-color: #13ce66;
      border-color: #13ce66;

      .el-switch__action {
        left: calc(100% - 22px);
      }
    }
  }
}

// Select/Multiselect Styling
:deep(.multiselect) {
  .multiselect__tags {
    border-radius: 8px;
    border: 1px solid transparent;
    background: #f3f3f5;
    box-shadow: none;
    padding: 8px 12px;
    min-height: 36px;
    transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);

    &:hover {
      border-color: transparent;
      box-shadow: none;
    }
  }

  &.multiselect--active .multiselect__tags {
    border-color: #01beb0;
    box-shadow: none;
  }

  .multiselect__single,
  .multiselect__input {
    color: $gray-700;
    font-weight: 500;
    font-size: 0.875rem;
    background: transparent;
    line-height: 24px;
    padding: 0;
    margin: 0;
    display: flex;
    align-items: center;
  }

  .multiselect__placeholder {
    color: $gray-400;
    font-size: 0.875rem;
    font-weight: 400;
  }

  .multiselect__content-wrapper {
    border-radius: 12px;
    border: 1px solid transparent;
    box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.1), 0 8px 10px -6px rgba(0, 0, 0, 0.08);
    margin-top: 6px;
  }

  .multiselect__option {
    border-radius: 8px;
    padding: 10px 12px;
    margin: 2px 6px;
    font-size: 0.9375rem;
    color: $gray-700;
    font-weight: 500;
    transition: all 0.15s cubic-bezier(0.4, 0, 0.2, 1);

    &--highlight {
      background-color: rgba(67, 73, 221, 0.08);
      color: $color-purple-text;
      transform: translateX(2px);
    }

    &--selected {
      background-color: rgba(67, 73, 221, 0.12);
      color: $color-purple-text;
      font-weight: 600;
    }
  }
}

// QR Code Section Styling
.qr-code-section {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.link-with-copy {
  display: flex;
  align-items: center;
  width: 100%;
  flex-wrap: wrap;
  gap: 0.5rem;
}

.primary-color-text {
  color: #005c6b;
  font-size: 0.875rem;
  font-weight: 500;
  text-decoration: none;
  word-break: break-all;
  transition: color 0.2s ease;
  flex: 1;
  min-width: 0;

  &:hover {
    color: #01beb0;
    text-decoration: underline;
  }
}

// Categories List
.categories-list {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
}

// Admins List Styling
.admins-list {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.admin-item {
  background-color: $gray-50;
  border: 1px solid $gray-200;
  border-radius: 8px;
  padding: 0.75rem;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);

  &:hover {
    background-color: color.adjust($color-purple-text, $lightness: 45%);
    border-color: $color-purple-text;
    transform: translateY(-1px);
    box-shadow: 0 2px 4px 0 rgba(67, 73, 221, 0.1);
  }

  &:active {
    transform: translateY(0);
  }
}

.add-admin-form {
  background-color: $gray-50;
  border: 1px solid $gray-200;
  border-radius: 8px;
  padding: 1rem;
}

.row-xs {
  margin-left: -0.25rem;
  margin-right: -0.25rem;

  > [class*="col"] {
    padding-left: 0.25rem;
    padding-right: 0.25rem;
  }
}

.size-32 {
  width: 32px;
  height: 32px;
}

.obj-f-c {
  object-fit: cover;
}

.rounded-circle {
  border-radius: 50%;
}

.lh-1 {
  line-height: 1;
  font-weight: 500;
  color: $gray-900;
  font-size: 0.875rem;
}

// Image Upload Styling
.img-uploader {
  border: 2px dashed $gray-300;
  border-radius: 8px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  transition: all 0.3s;
  background-color: $gray-50;
  min-height: 200px;
  height: 200px;

  &:hover {
    border-color: transparent;
    background-color: color.adjust($color-purple-text, $lightness: 45%);
  }

  .uploaded-image {
    width: 100%;
    height: 200px;
    object-fit: cover;
    display: block;
  }

  .upload-empty-state {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 1.5rem 1rem;
    height: 100%;
  }

  .img-uploader-icon {
    width: 48px;
    height: 48px;
    margin-bottom: 0.75rem;
    display: block;
    opacity: 0.5;
  }

  .upload-picture-text {
    text-align: center;
    color: $gray-600;
    font-size: 0.625rem !important;
    margin-bottom: 0.5rem;
    font-weight: 400;
    line-height: 1.2;
  }

  .fake-upload-button {
    // Styled as a button, not just text
    pointer-events: none; // Let the parent el-upload handle the click
    // Match the size of the "Change" button exactly
    height: 36px !important;
    padding: 0 20px !important;
    font-size: 0.875rem !important;
    font-weight: 600 !important;
    border-radius: 8px !important;
    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.03) !important;
    border-width: 1px !important;
  }

  .pin-bx {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    background: linear-gradient(to top, rgba(0,0,0,0.7), transparent);
    
    .el-button {
      // Ensure Change button matches Browse button
      height: 36px;
      padding: 0 20px;
      font-size: 0.875rem;
      font-weight: 600;
      border-radius: 8px;
    }
  }
}

// Additional specificity for upload text
:deep(.img-uploader) {
  .upload-picture-text {
    font-size: 0.625rem !important;
  }
}

// Tooltip Styling
:deep(.el-tooltip__trigger) {
  .size-18 {
    color: $gray-400;
    transition: color 0.2s ease;

    &:hover {
      color: $gray-600;
    }
  }
}

// Page Background
:deep(.app-main-content-layout) {
  background-color: $gray-50;
}

// Title Styling
:deep(h1) {
  font-size: 1.875rem;
  font-weight: 600;
  color: $gray-900;
  line-height: 1.2;
}

h5 {
  font-size: 1rem;
  font-weight: 600;
  color: $gray-900;
}

// Responsive Design
@media (max-width: 768px) {
  .c-org-edit-form {
    padding: 1.5rem;
  }

  .c-content-section {
    padding: 1.25rem;
    border-radius: 12px;
  }

  :deep(.grid-2-cols) {
    gap: 1rem;
  }

  :deep(.el-form-item) {
    margin-bottom: 1.25rem;

    .el-form-item__label {
      font-size: 0.8125rem;
    }

    .el-input__inner,
    .el-textarea__inner {
      font-size: 0.8125rem;
    }
  }

  :deep(.el-button) {
    padding: 8px 16px;
    font-size: 0.8125rem;
  }

  .link-input-group {
    flex-direction: column;
    align-items: stretch;

    .el-input {
      width: 100%;
    }

    .el-button {
      width: 100%;
    }
  }
}

@media (max-width: 576px) {
  .c-org-edit-form {
    padding: 1rem;
  }

  .c-content-section {
    padding: 1rem;
    border-radius: 12px;
  }
}
</style>

<script lang="ts">
import {
  defineComponent,
  reactive,
  ref,
  onMounted,
  computed,
} from 'vue';
import { mask } from 'vue-the-mask';
import { requiredRule, changedEmailRules } from '@/data/rules';
import VueMultiselect from 'vue-multiselect';
import QrcodeVue from 'qrcode.vue';
import { bullhorns, orgValues, channels } from '@/data/onboarding-static';
import fileUpload from '@/shared/upload';
import UserCommonSections from '../UserCommonSections.vue';
import shared from '../shared';
import { resizeAndConvertToPNG } from '@/shared/utility-functions';
import lowercaseEmail from '@/directives/lowercase-email.js';
import { ElMessage } from 'element-plus';
import { buildOrganizationEmbedCode } from '@/utils/embedParentScript';

const itemData = {
  name: '',
  slug: '',
  bullhorns,
  about: '',
  purpose: '',
  allies: bullhorns,
  values: orgValues,
  channels,
  interests: [],
  status: '',
  categories: [],
  orgType: '501(c)',
  location: '90068  Los Angeles, CA',
  email: 'emailname@provider.com',
  phone: '(123) 456-789',
  estdDate: new Date(),
  twoFactorAuthentication: 'Phone',
  personalReferralCode: '94le384ngle',
  betaTester: 'Yes',
  referralCodeUsed: '234uf22iMX3',
  avatar: '',
  background: '',
  createdAt: '',
  primaryAdmin: {
    name: 'FirstName LastName',
    imgUrl: '//picsum.photos/200/300?random=2',
  },
  adminEmail: '',
  isAddAdmin: false,
  admins: [],
  isStripeOnboarded: '',
  isFeatured: false,
};

export default defineComponent({
  name: 'ManageContentOrgEdit',
  components: { UserCommonSections, VueMultiselect, QrcodeVue },
  directives: { mask, lowercaseEmail },

  setup() {
    const {
      route,
      router,
      loading,
      getOrganization,
      approveOrDenyOrganization,
      getConfirm,
      dateAndTime,
      dobDate,
      updateOrgProfile,
      addAdminUserToOrgRequest,
      removeAdminUserFromOrgRequest,
    } = shared();
    const bUploads = fileUpload('backgrounds', 'Background');
    const { uploadStatus, beforeUpload, handleUploadRequest } = fileUpload('avatars', 'Avatar');

    const { orgId } = route.params;
    const item = reactive(itemData);
    const accountStatus = reactive({
      items: [
        {
          type: 'Active',
          value: true,
        },
        {
          type: 'Archived',
          value: false,
        },
      ],
    });
    
    const embedConfig = reactive({
      website: '',
    });
    const refForm = ref(null);
    const originalEmail = ref('');
    const uploading = reactive({
      avatar: false,
      background: false,
    });
    async function getOrganizationDetails() {
      const organization = await getOrganization(orgId);
      item.name = organization.name;
      item.slug = organization.slug;
      item.about = organization.about;
      item.purpose = organization.purpose;
      item.bullhorns = organization.bullhorns;
      item.values = organization.values;
      item.channels = organization.channels;
      item.email = organization.email;
      originalEmail.value = organization.email ?? '';
      item.background = organization.background;
      item.avatar = organization.avatar;
      item.categories = organization.organizationTypes;
      item.estdDate = dobDate(organization.dob);
      item.active = { type: organization.active ? 'Active' : 'Archived', value: organization.active };
      item.approved = organization.approved;
      item.denied = organization.denied;
      item.withdrawn = organization.withdrawn;
      item.is_creator = organization.is_creator;
      [item.createdAt] = dateAndTime(organization.createdAt);
      if (item.categories.length > 0) {
        item.orgType = organization.organizationTypes.join(',');
      }
      item.referralCodeUsed = organization.invite_code;
      item.primaryAdmin = organization.primaryAdmin;
      item.admins = organization.admins;
      item.isStripeOnboarded = item.stripe_onboarded ? 'Connected' : 'Not Connected';
      item.isFeatured = organization.isFeatured;
      item.interests = organization.interests;
      item.id = organization.id;
      item.stripe_onboarded = organization.stripe_onboarded;
    }

    onMounted(async () => {
      await getOrganizationDetails();
    });

    async function removeStripeConnection() {
      // TODO: Implement stripe removal
      ElMessage({
        message: 'Stripe removal not yet implemented',
        type: 'warning',
      });
    }

    const aboutTip = computed(() => {
      if (item.organization_type === 'NONPROFIT') {
        return 'Introduce your organization and primary reason for existing. Consider leaning into '
          + 'your org voice to include the founding backstory, your vision for tomorrow,'
          + ' and why your fruits of labor matter';
      }
      return 'Introduce your brand and primary reason for existing. '
        + 'Consider leaning into your brand voice to include the founding backstory, '
        + 'your vision for tomorrow, and why your fruits of labor matter.';
    });

    const purposeTip = computed(() => {
      if (item.organization_type === 'NONPROFIT') {
        return 'Define your "my purpose statement" to capture your catalyst and commitment. '
          + 'Consider including what you want to accomplish, who that will be for, and how you plan to make stuff better.';
      }
      return 'Define your brand\'s "purpose statement" to capture your catalyst, '
        + 'commitment, and responsibility. Consider including what you want to accomplish, '
        + 'who that will be for, and how you plan to make stuff better.';
    });

    const slugTip = computed(() => {
      return 'A slug is a URL-friendly version of your organization name. It creates clean, memorable URLs like "spotlight.xyz/web/org/your-org-name" instead of "spotlight.xyz/web/org/123". '
        + 'Slugs improve SEO, make sharing easier, and provide a professional appearance. Use lowercase letters, numbers, and hyphens only.';
    });

    async function approveOrg(opt) {
      let msg = 'Do you wish to approve. Are you Sure?';
      if (!opt) {
        msg = 'Do you wish to deny. Are you Sure?';
      }
      getConfirm(msg, async () => {
        loading.value = true;
        await approveOrDenyOrganization(orgId, opt);
        loading.value = false;
        if (!opt) {
          router.push('/manage/orgs-pending');
          return;
        }
        await getOrganizationDetails();
      });
    }

    async function updateProfileForOrg() {
      loading.value = true;
      try {
        const updated = await updateOrgProfile({
          id: orgId,
          name: item.name,
          slug: item.slug,
          about: item.about,
          purpose: item.purpose,
          avatar: item.avatar,
          background: item.background,
          active: item.active.value,
          is_creator: item.is_creator,
          isFeatured: item.isFeatured,
          email: item.email,
        });
        if (updated?.email != null) {
          item.email = updated.email;
        }
        await getOrganizationDetails();
        ElMessage({
          message: 'Organization profile updated successfully',
          type: 'success',
        });
      } catch (error) {
        console.error('Error updating organization profile:', error);
        
        // Extract error message from GraphQL response
        let errorMessage = 'Failed to update organization profile';
        if (error.graphQLErrors && error.graphQLErrors.length > 0) {
          errorMessage = error.graphQLErrors[0].message;
        } else if (error.message) {
          errorMessage = error.message;
        }
        
        ElMessage({
          message: errorMessage,
          type: 'error',
        });
      } finally {
        loading.value = false;
      }
    }

    function validateForm() {
      refForm.value.validate(async (valid) => {
        if (valid) {
          try {
            await updateProfileForOrg();
          } catch (error) {
            // Error is already handled in updateProfileForOrg
            console.error('Error in validateForm:', error);
          }
        }
        return false;
      });
    }

    function viewUser(id, event) {
      event.preventDefault();
      router.push(`/manage/users/${id}/edit`);
    }

    async function handleAvatarUpload(payload) {
      try {
        uploading.avatar = true;
        
        if (payload.file && payload.file.type.startsWith('image/')) {
          const processedImage = await resizeAndConvertToPNG(payload.file, 800, 800, 0.9);
          payload.file = processedImage;
        }
        
        await handleUploadRequest(payload);
        uploading.avatar = false;
        
        if (uploadStatus.status === 'ok') {
          item.avatar = uploadStatus.resourceUrl;
        }
      } catch (error) {
        console.error('Error processing or uploading avatar:', error);
        uploading.avatar = false;
      }
    }

    async function handleBackgroundUpload(payload) {
      try {
        uploading.background = true;
        
        if (payload.file && payload.file.type.startsWith('image/')) {
          const processedImage = await resizeAndConvertToPNG(payload.file, 1200, 800, 0.9);
          payload.file = processedImage;
        }
        
        await bUploads.handleUploadRequest(payload);
        uploading.background = false;

        if (bUploads.uploadStatus.status === 'ok') {
          item.background = bUploads.uploadStatus.resourceUrl;
        }
      } catch (error) {
        console.error('Error processing or uploading background:', error);
        uploading.background = false;
      }
    }

    function handleSuccess() {
    }

    function handleError() {
    }

    function backLink() {
      if (!item.approved && !item.denied) {
        return '/manage/orgs-pending';
      }
      return '/manage/orgs';
    }

    async function addAdminUserToOrg() {
      loading.value = true;
      const organizationId = orgId;
      const result = await addAdminUserToOrgRequest({
        orgId: organizationId,
        userEmail: item.adminEmail,
      });
      if (result && result.addAdminUserToOrg === true) {
        item.isAddAdmin = false;
        item.adminEmail = '';
      }
      await getOrganizationDetails();
      loading.value = false;
    }

    async function removeAdminUserFromOrg(id, event) {
      event.preventDefault();
      loading.value = true;
      const organizationId = orgId;
      await removeAdminUserFromOrgRequest({
        orgId: organizationId,
        userId: id,
      });
      await getOrganizationDetails();
      loading.value = false;
    }

    function sanitizeSlug() {
      item.slug = item.slug.replace(/[^a-z0-9-]/g, '').toLowerCase();
    }

    // Computed property for organization profile URL
    const orgUrl = computed(() => {
      if (item.slug) {
        return `${import.meta.env.VITE_WEB_BASE_URL}/web/org/${item.slug}?tab=shop`;
      }
      // Fallback to ID-based URL when no slug is available
      const orgId = item.id || route.params.orgId;
      return `${import.meta.env.VITE_WEB_BASE_URL}/web/profile/organization/${orgId}?tab=shop`;
    });

    // Computed property for organization deep link (ID-based for CMS)
    const orgDeepLink = computed(() => {
      const orgId = item.id || route.params.orgId;
      return `/profile/organization/${orgId}`;
    });

    // Computed property for embed code
    const embedCode = computed(() => {
      const baseUrl = import.meta.env.VITE_WEB_BASE_URL || 'https://spotlight-frontend-staging.azurewebsites.net';
      const organizationId = item.id || route.params.orgId;

      return buildOrganizationEmbedCode({
        baseUrl,
        organizationId,
        embedSource: embedConfig.website || undefined,
      });
    });

    function sanitizeWebsite() {
      // Remove http(s):// and www. for consistency
      embedConfig.website = embedConfig.website
        .replace(/^https?:\/\//, '')
        .replace(/^www\./, '')
        .toLowerCase();
    }

    async function copyTextToClipboard(text: string) {
      if (navigator.clipboard?.writeText) {
        await navigator.clipboard.writeText(text);
        return;
      }

      const textArea = document.createElement('textarea');
      textArea.value = text;
      textArea.style.position = 'fixed';
      textArea.style.left = '-999999px';
      textArea.style.top = '-999999px';
      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();

      try {
        document.execCommand('copy');
      } finally {
        document.body.removeChild(textArea);
      }
    }

    async function copyEmbedCode() {
      try {
        await copyTextToClipboard(embedCode.value);
        ElMessage({
          message: 'Embed code copied to clipboard!',
          type: 'success',
        });
      } catch (error) {
        console.error('Failed to copy embed code:', error);
        ElMessage({
          message: 'Failed to copy embed code',
          type: 'error',
        });
      }
    }

    async function copyOrgDeepLink() {
      try {
        await copyTextToClipboard(orgDeepLink.value);
        ElMessage({
          message: 'Organization deep link copied to clipboard!',
          type: 'success',
        });
      } catch (error) {
        console.error('Failed to copy organization deep link:', error);
        ElMessage({
          message: 'Failed to copy deep link',
          type: 'error',
        });
      }
    }

    async function copyOrgUrl() {
      try {
        const urlToCopy = orgUrl.value;

        if (!urlToCopy) {
          throw new Error('URL is empty');
        }

        await copyTextToClipboard(urlToCopy);
        ElMessage({
          message: 'Organization profile URL copied to clipboard!',
          type: 'success',
        });
      } catch (error) {
        console.error('Failed to copy organization URL:', error);
        ElMessage({
          message: 'Failed to copy URL. Please copy manually.',
          type: 'error',
        });
      }
    }

    return {
      // data
      loading,
      rules: {
        name: requiredRule('Name'),
        email: changedEmailRules(() => originalEmail.value),
      },
      item,
      refForm,
      // methods
      validateForm,
      viewUser,
      beforeUpload,
      handleSuccess,
      handleError,
      handleAvatarUpload,
      handleBackgroundUpload,
      bUploads,
      uploading,
      aboutTip,
      purposeTip,
      approveOrg,
      backLink,
      addAdminUserToOrg,
      removeAdminUserFromOrg,
      removeStripeConnection,
      accountStatus,
      slugTip,
      sanitizeSlug,
      orgUrl,
      orgDeepLink,
      embedConfig,
      embedCode,
      sanitizeWebsite,
      copyEmbedCode,
      copyOrgDeepLink,
      copyOrgUrl,
    };
  },
});
</script>
